import PackageCard from "@/components/Card";
import { useExpedition } from "@/context/Expeditions";

export default function AboutHome({ }: any) {
  const { expeditions } = useExpedition();

  // Filter bestsellers and separate by collection type
  const bestSellers = expeditions.filter((item: any) => item.isBestseller);

  const mountaineeringExpeditions = bestSellers
    .filter((item: any) => item.collections?.slug === "mountaineering")
    .slice(0, 4);

  const trekkingExpeditions = bestSellers
    .filter((item: any) => item.collections?.slug === "trekking")
    .slice(0, 4);

  return (
    <div className="w-full mx-auto py-12 md:py-20 relative">
      <div className="flex flex-col gap-10 lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto">
        <div className="home-about-title">
          <div className="lg:w-full mx-auto text-center flex-col flex flex-wrap gap-2 justify-center items-center">
            <h2 className="lg:text-6xl md:text-4xl sm:text-3xl text-2xl title font-extrabold text-center uppercase">
              Best Sellers
            </h2>
            <p className="text-zinc-700 mt-4 home-about-desc md:text-lg text-sm leading-relaxed xl:w-[80%]">
              At{" "}
              <span className="font-semibold text-black">
                Infinity Adventure Nepal Pvt. Ltd.
              </span>
              , we specialize in crafting unforgettable Mountaineering and
              Trekking experiences in the capital of mountains. Join us for an
              adventure of a lifetime and create memories that will last a
              lifetime.
            </p>
          </div>
        </div>

        <div className="md:my-10 my-2 flex flex-col gap-16">
          {/* Mountaineering Section */}
          <div className="flex flex-col gap-8">
            <h3 className="text-3xl font-bold text-center">
              Mountaineering Expeditions
            </h3>
            <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4 gap-y-8 relative">
              {mountaineeringExpeditions.map((item: any, index: number) => (
                <PackageCard
                  key={`mountaineering-${item._id}-${index}`}
                  item={item}
                  className="hover:shadow-lg"
                  viewMoreLink={`/expedition/${item.slug}`}
                  enquiryLink={`/booking/${item.slug}`}
                />
              ))}
            </div>
          </div>

          {/* Trekking Section */}
          <div className="flex flex-col gap-8">
            <h3 className="text-3xl font-bold text-center">
              Trekking Adventures
            </h3>
            <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4 gap-y-8 relative">
              {trekkingExpeditions.map((item: any, index: number) => (
                <PackageCard
                  key={`trekking-${item._id}-${index}`}
                  item={item}
                  className="hover:shadow-lg"
                  viewMoreLink={`/expedition/${item.slug}`}
                  enquiryLink={`/booking/${item.slug}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
